module.exports = __webpack_public_path__ + "img/cover.2ceb6fbb.jpg";